import { KgInsightMention } from '@api/api/kg-insights';
import { format, parseISO, startOfDay, subDays } from 'date-fns';

import { PulseSentimentBreakdown, PulseSentimentDay } from '../pulse-types';
import { MENTIONS_WINDOW_DAYS } from '../services/theme-mentions-service';

const DAY_KEY_FORMAT = 'yyyy-MM-dd';
const MENTION_LIMIT_PER_DAY = 10;

const emptyCounts = () => ({ positive: 0, negative: 0, neutral: 0 });

const dayMentionTotal = (counts: PulseSentimentDay['counts']) =>
  counts.positive + counts.negative + counts.neutral;

export const buildSentimentBreakdown = (
  mentions: KgInsightMention[]
): PulseSentimentBreakdown => {
  const totals = emptyCounts();
  const countsByDay = new Map<string, PulseSentimentDay['counts']>();

  for (const mention of mentions) {
    if (!mention.sentiment) {
      continue;
    }

    const date = format(parseISO(mention.created_at), DAY_KEY_FORMAT);
    const counts = countsByDay.get(date) ?? emptyCounts();

    counts[mention.sentiment] += 1;
    totals[mention.sentiment] += 1;
    countsByDay.set(date, counts);
  }

  const today = new Date();
  const days: PulseSentimentDay[] = [];

  if (countsByDay.size > 0) {
    for (let offset = MENTIONS_WINDOW_DAYS; offset >= 0; offset--) {
      const date = format(startOfDay(subDays(today, offset)), DAY_KEY_FORMAT);
      days.push({ date, counts: countsByDay.get(date) ?? emptyCounts() });
    }
  }

  return {
    totals,
    days,
    hasDayAboveMentionLimit: days.some(
      day => dayMentionTotal(day.counts) > MENTION_LIMIT_PER_DAY
    ),
  };
};
